/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_End_Open_Orders_WarningInputs */

const vi_trip_end_open_orders_warning = /** @type {(inputs: Trip_End_Open_Orders_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn đơn chưa hoàn tất`)
};

/**

* @param {Trip_End_Open_Orders_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_end_open_orders_warning = /** @type {((inputs?: Trip_End_Open_Orders_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_End_Open_Orders_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_end_open_orders_warning(inputs)
});